import React, { useState, useEffect, useCallback } from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter } from '../../styles/WrapperStyles';
import styled from 'styled-components';
import { getDateWithTime } from '../../utils';
import urls from '../../api/urls.json';
import { authorizedHttpGet } from '../../api/httpCalls';
import './Modal.css';

const ParentDiv = styled.div`
    width: 800px;
    height: 400px;
    border-radius: 20px;
    overflow-y: auto;
`;

const TitleView = styled.div`
    font-family: 'Gilroy-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #484848;
    text-align: center;
    margin-bottom: 20px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const Th = styled.th`
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    background-color: #f2f2f2;
    font-family: 'Gilory-Semi';
    font-size: 18px;
    font-weight: 600;
`;

const Td = styled.td`
    border: 1px solid #ddd;
    padding: 8px;
    font-family: 'Gilory-Semi';
    font-size: 18px;
`;

function CuratorLogHistoryModal(props) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);

    const processData = useCallback((curatorLogHistory) => {
        return curatorLogHistory.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }, []);

    const fetchCuratorLogHistory = useCallback(async () => {
        try {
            const response = await authorizedHttpGet(urls.FETCH_CURATOR_LOGS, { ref: props.userRef });
            if (response.status && response.data) {
                setData(processData(response.data));
                setError(false);
            } else {
                setData([]);
                setError(false);
            }
        } catch (err) {
            setError(true);
        }
    }, [props.userRef, processData]);

    useEffect(() => {
        fetchCuratorLogHistory();
    }, [fetchCuratorLogHistory]);

    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <FlexWrapperCenter>
                    <TitleView>Curator Log History</TitleView>
                </FlexWrapperCenter>
                {error ? (
                    <FlexWrapperCenter>
                        <div style={{ color: 'red', padding: '16px', textAlign: 'center' }}>
                            Error occurred while fetching curator log history.
                        </div>
                    </FlexWrapperCenter>
                ) : data.length === 0 ? (
                    <FlexWrapperCenter>
                        <div style={{ color: '#484848', padding: '16px', textAlign: 'center' }}>
                            No curator log history found.
                        </div>
                    </FlexWrapperCenter>
                ) : (
                    <Table>
                        <thead>
                            <tr>
                                <Th>Datetime</Th>
                                <Th>Curator Name</Th>
                                <Th>Action Type</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <Td>{getDateWithTime(item.created_at)}</Td>
                                    <Td>{item.admin_name}</Td>
                                    <Td>{item.activity_type}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </ParentDiv>
        </BaseModel>
    );
}

export default CuratorLogHistoryModal;
